import { defineAction } from '~/prix'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import residenceIdentificationPlateCreateAction from './residenceIdentificationPlateCreate.action.json' with { type: 'json' }
import { residenceIdentificationPlateObject } from '../residenceIdentificationPlateObject'

const residenceIdentificationPlateCreateDefinition = defineAction({
  ...residenceIdentificationPlateCreateAction,

  input: z.object({
    id: residenceIdentificationPlateObject.shape.id.nullish(),
    residenceId: residenceIdentificationPlateObject.shape.residenceId,
    manufacturedAt: dateOrIsoString().nullish(),
    deliveredAt: dateOrIsoString().nullish(),
    createdAt: dateOrIsoString().nullish(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({
    id: residenceIdentificationPlateObject.shape.id,
    code: residenceIdentificationPlateObject.shape.code,
  }),
})

export default residenceIdentificationPlateCreateDefinition
